import { useMemo, type ReactNode } from "react";
import { AnnouncementServiceProvider } from "./announcement";

import { useAuth } from "../contexts/AuthContext";
import { createAnnouncementService } from "../services/announcementService";

interface Props {
  children: ReactNode;
}

function AnnouncementServiceBridge({ children }: Props) {
  const { user, openAuthModal } = useAuth();

  const service = useMemo(() => createAnnouncementService(), []);

  const auth = useMemo(
    () => ({
      isAuthenticated: user !== null,
      currentUserId: user?.id ?? null,
      isPaying: user?.isPaying ?? false,
      email: user?.email ?? null,
      firstName: user?.firstName ?? null,
      requestSignIn: openAuthModal,
    }),
    [user, openAuthModal],
  );

  return (
    <AnnouncementServiceProvider service={service} auth={auth}>
      {children}
    </AnnouncementServiceProvider>
  );
}

export default AnnouncementServiceBridge;
